import Navbar from "../shared/Navbar/Navbar";

const Layout = ({ children, showBar = true }) => {
  return (
    <>
      <Navbar handleNavbarSession={() => {}} />
      <main style={{ marginTop: "0px" }}>{children}</main>
    </>
  );
};

export default Layout;

